module.exports = __webpack_public_path__ + "static/media/paragraph-rtl.095675bb.svg";